import {
  GET_AGENDA_REQUEST,
  GET_AGENDA_SUCCESS,
  GET_AGENDA_FAILURE,
  SET_EVENTS_AGENDA,
  RESET_EVENTOS,
  SET_COMPLETADO_EVENTO,
  DELETE_EVENT,
  CREATE_EVENT,
  UPDATE_EVENT,
} from '../../constants/agenda/agenda.constants';

export const getAgendaAction = (page = 1, start = 0, limit = 99999, tipoTarea = '', mesActivo = Date()) => ({
  type: GET_AGENDA_REQUEST,
  payload: {
    page, start, limit, tipoTarea, mesActivo,
  },
});

export const getAgendaSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_AGENDA_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getAgendaFailureAction = error => ({
  type: GET_AGENDA_FAILURE,
  payload: error,
});

export const addEventsCalendar = events => ({
  type: SET_EVENTS_AGENDA,
  payload: {
    events,
  },
});

export const resetEventos = () => ({
  type: RESET_EVENTOS,
  payload: {
    events: [],
  },
});

export const setCompletadoEvento = id => ({
  type: SET_COMPLETADO_EVENTO,
  payload: {
    id,
  },
});

export const deleteEvent = (id, valueDeleteGroup) => ({
  type: DELETE_EVENT,
  payload: {
    id, valueDeleteGroup,
  },
});

export const createEvent = values => ({
  type: CREATE_EVENT,
  payload: {
    values,
  },
});

export const updateEvent = values => ({
  type: UPDATE_EVENT,
  payload: {
    values,
  },
});
